import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import cert1 from '../../assets/images/Social-responsibilty/Certifcate(1).jpeg';
import cert2 from '../../assets/images/Social-responsibilty/Certifcate(2).jpeg';
import cert3 from '../../assets/images/Social-responsibilty/Certifcate(3).jpeg';
import styles from './SocialResponsibility.module.css';

const SocialResponsibility = () => {
  const { t } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const certificates = [
    { id: 1, image: cert1, alt: 'Certificate 1' },
    { id: 2, image: cert2, alt: 'Certificate 2' },
    { id: 3, image: cert3, alt: 'Certificate 3' }
  ];

  // Auto-play carousel
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % certificates.length);
    }, 4000); // Change slide every 4 seconds

    return () => clearInterval(interval);
  }, [isAutoPlaying, certificates.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 8000);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % certificates.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 8000);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + certificates.length) % certificates.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 8000);
  };

  return (
    <section className={styles.socialSection}>
      <div className={styles.container}>
        {/* Section Header */}
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>{t('social.title')}</h2>
          <div className={styles.titleUnderline}></div>
        </div>

        {/* Content Layout */}
        <div className={styles.content}>
          {/* Text Content */}
          <div className={styles.textContainer}>
            <div className={styles.textContent}>
              <p className={styles.description}>
                {t('social.description')}
              </p>
            </div>
          </div>

          {/* Certificates Carousel */}
          <div className={styles.carouselContainer}>
            <div className={styles.carousel}>
              {certificates.map((cert, index) => (
                <div
                  key={cert.id}
                  className={`${styles.carouselSlide} ${
                    index === currentSlide ? styles.carouselSlideActive : ''
                  }`}
                >
                  <div className={styles.certificateImageWrapper}>
                    <img
                      src={cert.image}
                      alt={cert.alt}
                      className={styles.certificateImage}
                    />
                    <button
                      className={styles.viewButton}
                      onClick={() => window.open(cert.image, '_blank')}
                      aria-label={t('social.viewCertificate')}
                    >
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                      <span>{t('social.viewCertificate')}</span>
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Navigation Arrows */}
            <button
              className={`${styles.carouselButton} ${styles.carouselButtonPrev}`}
              onClick={prevSlide}
              aria-label="Previous certificate"
            >
              <svg fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            <button
              className={`${styles.carouselButton} ${styles.carouselButtonNext}`}
              onClick={nextSlide}
              aria-label="Next certificate"
            >
              <svg fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            </button>

            {/* Dots Indicator */}
            <div className={styles.dotsContainer}>
              {certificates.map((_, index) => (
                <button
                  key={index}
                  className={`${styles.dot} ${
                    index === currentSlide ? styles.dotActive : ''
                  }`}
                  onClick={() => goToSlide(index)}
                  aria-label={`Go to certificate ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialResponsibility;

